import { Switch, Route, Redirect } from '@react-router';
import { COLLABORATORS_ROUTES } from './Collaborators.routes';
import React from 'react';
import { AcceptInvite } from './routes/Accept/AcceptInvite';

export const Collaborators = (props: { eventHandle: string | null }) => {
  return (
    <Switch>
      <Route
        path={COLLABORATORS_ROUTES.accept.path}
        render={({ match }) => {
          return (
            <AcceptInvite
              eventHandle={props.eventHandle || ''}
              inviteUUID={match.params.inviteUUID}
            />
          );
        }}
      ></Route>
      <Route render={() => <Redirect to={`/${props.eventHandle}`} />} />
    </Switch>
  );
};
